export const MINIMAL_CONTENT_SUBDOMAINS = [
  'demo',
  'demomas',
  'demomas-campo',
  'uniminuto-men',
  'skills-on-demand',
];

/**
 * Vista completa (toolbar, comentarios, rating, etc.).
 * Solo estos subdominios; el resto usa branded nav por defecto.
 */
export const FULL_CONTENT_SUBDOMAINS = ['sikdemo'];

export function getSubdomain() {
  const fromEnv = (process.env.VUE_APP_SUBDOMAIN || '').trim();
  if (fromEnv) {
    return fromEnv;
  }

  const sub = window.location.hostname.split('.')[0];
  return sub && sub !== 'localhost' ? sub : 'app';
}

export function isMinimalContentSubdomain() {
  return MINIMAL_CONTENT_SUBDOMAINS.includes(getSubdomain());
}

export function isFullContentSubdomain() {
  return FULL_CONTENT_SUBDOMAINS.includes(getSubdomain());
}

/** Logo + contenido + nav. Por defecto salvo minimal o full. */
export function isBrandedNavContentSubdomain() {
  if (isMinimalContentSubdomain()) {
    return false;
  }
  if (isFullContentSubdomain()) {
    return false;
  }
  return true;
}
